// extracted by mini-css-extract-plugin
module.exports = {"IMAGE_SIZE":"26px","imageSize":"26px","container":"_1mogW","image":"_1Mmr1"};